import React, { useEffect, useRef, useState } from "react";
import Button from "../components/base/Button";
import FormField from "../components/FormField";
import { Logo } from "../components/App";
import { errorMessage } from "../shared/utils/validators";
import * as Yup from "yup";
import { useFormik } from "formik";
import AuthService from "../services/AuthService";
import Icons from "../components/Icons";
import FormFieldGroup from "../components/FormFieldGroup";
import { Alert, Snackbar } from "@mui/material";

document.title = "Sign up — Orkaapps";

function SignUpPage() {
  const $firstName = useRef();
  const [visible, setVisible] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isOtpView, setOtpView] = useState(false);
  const [mobileVerificationId, setMobileVerificationId] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const schema = Yup.object().shape({
    firstName: Yup.string()
      .trim()
      .required("Required first name")
      .max(50, "First name should not exceed 50 characters"),
    mobile: Yup.string()
      .required("Required mobile number")
      .matches(/^[0-9]{10}$/, "Enter a valid 10 digit mobile number"),
    password: Yup.string()
      .required("Required password")
      .min(6, "Password should be at least 6 characters")
      .max(25, "Password should not exceed 25 characters"),
  });

  const otpSchema = Yup.object().shape({
    otp: Yup.string()
      .required("OTP is required")
      .matches(/^[0-9]{4,6}$/, "Enter a valid OTP"),
  });

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      mobile: "",
      password: "",
    },
    validationSchema: schema,
    onSubmit: handleGetStarted,
  });

  const otpFormik = useFormik({
    initialValues: { otp: "" },
    validationSchema: otpSchema,
    onSubmit: handleOtpVerify,
  });

  useEffect(() => {
    $firstName.current && $firstName.current.focus();
  }, []);

  async function handleGetStarted(values) {
    setFormSubmitted(true);
    try {
      const res = await AuthService.signupVerificationCode(
        values.mobile.trim(),
        values.firstName.trim()
      );
      if (res.id?.mobileVerificationId) setMobileVerificationId(res.id.mobileVerificationId);
      setOtpView(true);
    } catch (error) {
        console.log('error', error);
        
        const message = errorMessage(error);
      if (message) {
        setSnackbar({
        open: true,
        message: message || "Something went wrong",
        severity: "error",
      });
      } else {
        setSnackbar({
        open: true,
        message: error.response?.data?.error || "Something went wrong",
        severity: "error",
      });
      }
    }
  }
  async function handleOtpVerify({ otp }) {
    setFormSubmitted(true);
    try {
      const payload = {
        firstName: formik.values.firstName.trim(),
        lastName: formik.values.lastName.trim(),
        mobile: formik.values.mobile.trim(),
        password: formik.values.password.trim(),
        mobileVerificationCode: mobileVerificationId ? otp : null,
        mobileVerificationId,
      };
      await AuthService.createAccount(payload);
      // const account = await MyAccountService.fetch();
      // console.log('account', account);
      
      // const organizationId = account.getOrganizationId();
      // console.log('orgid', organizationId);
      
      // if (!organizationId) return window.location.replace("/create-service");
      // const service = await ServicesService.getOrganizationServices({ organizationId });
      // console.log('ser', service);
      
      // if (service.length === 0) return window.location.replace("/create-service");
      window.location.replace("/");
    } catch (error) {
      setSnackbar({
        open: true,
        message: errorMessage(error) || "Something went wrong",
        severity: "error",
      });
    }
  }

  function snackBar() {
      return (
        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          <Alert
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            severity={snackbar.severity}
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      );
    }

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 420,
          background: "#fff",
          borderRadius: 16,
          boxShadow: '0 2px 16px rgba(215, 225, 255, 0.94)',
          padding: "32px 24px",
          margin: "32px 0",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Logo />
        <div style={{ marginTop: 16, marginBottom: 8, fontWeight: 700, fontSize: 22, color: "#222" }}>
          Create your Orkaaps account
        </div>
        <div style={{ color: "#666", fontSize: 15, marginBottom: 24, textAlign: "center" }}>
          Start sending messages.
        </div>
        {!isOtpView ? (
          <form onSubmit={formik.handleSubmit} style={{ width: "100%" }}>
                          <FormFieldGroup>
                              <FormField
                                  ref={$firstName}
                                  type="auth-text"
                                  name="firstName"
                                  placeholder="First Name"
                                  value={formik.values.firstName}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={(formSubmitted || formik.submitCount > 0) &&
                                      formik.touched.firstName &&
                                      formik.errors.firstName}
                                  style={{
                                      fontSize: 15,
                                      padding: "10px 12px",
                                      borderRadius: 8,
                                      border: "1px solid #e0e0e0",
                                      background: "#f8f9fa",
                                  }} />
                          <FormField
                              type="auth-text"
                              name="lastName"
                              placeholder="Last Name"
                              value={formik.values.lastName}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={(formSubmitted || formik.submitCount > 0) &&
                                  formik.touched.lastName &&
                                  formik.errors.lastName}
                              style={{
                                  fontSize: 15,
                                  padding: "10px 12px",
                                  borderRadius: 8,
                                  border: "1px solid #e0e0e0",
                                  background: "#f8f9fa",
                              }} />
                      </FormFieldGroup>
                    <div style={{ marginBottom: 18 }}>
                          <FormField
                              type="auth-text"
                              name="mobile"
                              placeholder="Whatsapp Number"
                              value={formik.values.mobile}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={(formSubmitted || formik.submitCount > 0) &&
                                  formik.touched.mobile &&
                                  formik.errors.mobile}
                              style={{
                                  fontSize: 15,
                                  padding: "10px 12px",
                                  borderRadius: 8,
                                  border: "1px solid #e0e0e0",
                                  background: "#f8f9fa",
                              }} />
                      </div><div style={{ marginBottom: 18 }}>
                          <FormField
                              autoComplete="off"
                              name="password"
                              placeholder="Password"
                              value={formik.values.password}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={(formSubmitted || formik.submitCount > 0) &&
                                  formik.touched.password &&
                                  formik.errors.password}
                              type={visible ? "text" : "password"}
                              iconSuffix={formik.values.password && (
                                  <div
                                      style={{ cursor: "pointer" }}
                                      onClick={() => setVisible(!visible)}
                                  >
                                      {visible ? Icons.Visible : Icons.VisibleOff}
                                  </div>
                              )}
                              maxLength={25}
                              style={{
                                  fontSize: 15,
                                  padding: "10px 12px",
                                  borderRadius: 8,
                                  border: "1px solid #e0e0e0",
                                  background: "#f8f9fa",
                              }} />
                      </div><p style={{ margin: 0, paddingBottom: 15, lineHeight: 1.8, paddingTop: "3px", fontSize: 13 }}>
                          By continuing, you agree to our{" "}
                          <a className="ui-link" href="/terms" style={{ color: "#1976d2" }}>Terms and conditions</a>{" "}
                          and{" "}
                          <a className="ui-link" href="/privacy" style={{ color: "#1976d2" }}>Privacy Policy</a>.
                      </p><Button
                          type="submit"
                          appearance="auth-btn"
                          style={{
                              width: "100%",
                              padding: "12px",
                              fontSize: 16,
                              borderRadius: 8,
                              background: "#1976d2",
                              color: "#fff",
                              fontWeight: 600,
                              border: "none",
                              boxShadow: "0 2px 8px rgba(25,118,210,0.08)",
                              cursor: "pointer",
                              marginTop: 8
                          }}
                      >
                          Get Started
                      </Button>
          </form>
        ) : (
          <form onSubmit={otpFormik.handleSubmit} style={{ width: "100%" }}>
            <div style={{ marginBottom: 18, textAlign: "center", fontWeight: 500, fontSize: 16 }}>
              Enter the OTP sent to <span style={{ fontWeight: 700 }}>{formik.values.mobile}</span>
            </div>
            <div style={{ marginBottom: 18 }}>
              <FormField
                type="auth-text"
                name="otp"
                placeholder="Enter OTP"
                value={otpFormik.values.otp}
                onChange={otpFormik.handleChange}
                onBlur={otpFormik.handleBlur}
                error={
                  (formSubmitted || otpFormik.submitCount > 0) &&
                  otpFormik.touched.otp &&
                  otpFormik.errors.otp
                }
                style={{
                  fontSize: 15,
                  padding: "10px 12px",
                  borderRadius: 8,
                  border: "1px solid #e0e0e0",
                  background: "#f8f9fa",
                  textAlign: "center",
                  letterSpacing: 2
                }}
              />
              {otpFormik.touched.otp && otpFormik.errors.otp && (
                <div style={{ color: "#dc3545", fontSize: 13, marginTop: 4, textAlign: "center" }}>
                  {otpFormik.errors.otp}
                </div>
              )}
            </div>
            <Button
              type="submit"
              appearance="auth-btn"
              style={{
                width: "100%",
                padding: "12px",
                fontSize: 16,
                borderRadius: 8,
                background: "#1976d2",
                color: "#fff",
                fontWeight: 600,
                border: "none",
                boxShadow: "0 2px 8px rgba(25,118,210,0.08)",
                cursor: "pointer",
                marginTop: 8
              }}
            >
              Verify
            </Button>
          </form>
        )}
        <div style={{ margin: "auto", paddingTop: 24, fontSize: 15, textAlign: "center" }}>
          Already have an account?
          <a style={{ marginLeft: "5px", color: "#1976d2" }} href="/signin" className="ui-link">
            Sign in
          </a>
        </div>
        {snackBar()}
      </div>
    </div>
  );
}

export { SignUpPage };

